import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { billing } from "./api";
import { useAuth } from "./auth-context";

const BalanceCtx = createContext(null);

export const BalanceProvider = ({ children }) => {
  const { user } = useAuth();
  const [balance, setBalance] = useState(null);

  const refresh = useCallback(async () => {
    if (!user) {
      setBalance(null);
      return;
    }
    try {
      setBalance(await billing.balance());
    } catch (e) {
      // fail silent — balance display is non-critical
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <BalanceCtx.Provider value={{ balance, refresh }}>{children}</BalanceCtx.Provider>;
};

export const useBalance = () => useContext(BalanceCtx);
